/* eslint-disable */
// @ts-nocheck

import { type Client, formDataBodySerializer, type Options as Options2, type TDataShape } from './client';
import { client } from './client.gen';
import type { DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdData, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdErrors, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdResponses, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdData, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdErrors, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdResponses, DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdData, DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdErrors, DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdResponses, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdErrors, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdData, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdErrors, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdResponses, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponses, DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData, DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdErrors, DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdResponses, DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultData, DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultErrors, DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultResponses, DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdData, DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdErrors, DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdResponses, DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData, DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponses, DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdData, DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdErrors, DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdResponses, DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdData, DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdErrors, DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdResponses, DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData, DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdErrors, DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdResponses, GetApiV1MeOrganizationsData, GetApiV1MeOrganizationsErrors, GetApiV1MeOrganizationsResponses, GetApiV1MeWeddingsData, GetApiV1MeWeddingsErrors, GetApiV1MeWeddingsResponses, GetApiV1OrganizationsByOrganizationIdData, GetApiV1OrganizationsByOrganizationIdErrors, GetApiV1OrganizationsByOrganizationIdMembersData, GetApiV1OrganizationsByOrganizationIdMembersErrors, GetApiV1OrganizationsByOrganizationIdMembersResponses, GetApiV1OrganizationsByOrganizationIdResponses, GetApiV1OrganizationsByOrganizationIdWeddingsData, GetApiV1OrganizationsByOrganizationIdWeddingsErrors, GetApiV1OrganizationsByOrganizationIdWeddingsResponses, GetApiV1StaffInvitationsByTokenData, GetApiV1StaffInvitationsByTokenErrors, GetApiV1StaffInvitationsByTokenResponses, GetApiV1WeddingsByWeddingIdActivitiesBlessingsData, GetApiV1WeddingsByWeddingIdActivitiesBlessingsErrors, GetApiV1WeddingsByWeddingIdActivitiesBlessingsResponses, GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateData, GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateErrors, GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateResponses, GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData, GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoErrors, GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoResponses, GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData, GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateErrors, GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateResponses, GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData, GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsErrors, GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsResponses, GetApiV1WeddingsByWeddingIdAdminActivitiesWallData, GetApiV1WeddingsByWeddingIdAdminActivitiesWallErrors, GetApiV1WeddingsByWeddingIdAdminActivitiesWallResponses, GetApiV1WeddingsByWeddingIdAdminCheckinsData, GetApiV1WeddingsByWeddingIdAdminCheckinsErrors, GetApiV1WeddingsByWeddingIdAdminCheckinsResponses, GetApiV1WeddingsByWeddingIdAdminDisplayTokensData, GetApiV1WeddingsByWeddingIdAdminDisplayTokensErrors, GetApiV1WeddingsByWeddingIdAdminDisplayTokensResponses, GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData, GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdErrors, GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponses, GetApiV1WeddingsByWeddingIdAdminGuestsData, GetApiV1WeddingsByWeddingIdAdminGuestsErrors, GetApiV1WeddingsByWeddingIdAdminGuestsResponses, GetApiV1WeddingsByWeddingIdAdminLineChannelData, GetApiV1WeddingsByWeddingIdAdminLineChannelErrors, GetApiV1WeddingsByWeddingIdAdminLineChannelResponses, GetApiV1WeddingsByWeddingIdAdminLineChannelVerifyStreamData, GetApiV1WeddingsByWeddingIdAdminLineChannelVerifyStreamErrors, GetApiV1WeddingsByWeddingIdAdminLineChannelVerifyStreamResponses, GetApiV1WeddingsByWeddingIdAdminLineUsersData, GetApiV1WeddingsByWeddingIdAdminLineUsersErrors, GetApiV1WeddingsByWeddingIdAdminLineUsersResponses, GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData, GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdErrors, GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdResponses, GetApiV1WeddingsByWeddingIdAdminRichmenusData, GetApiV1WeddingsByWeddingIdAdminRichmenusErrors, GetApiV1WeddingsByWeddingIdAdminRichmenusResponses, GetApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData, GetApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponses, GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData, GetApiV1WeddingsByWeddingIdAdminRichmenusSetsResponses, GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdData, GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdErrors, GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdResponses, GetApiV1WeddingsByWeddingIdAdminRsvpsData, GetApiV1WeddingsByWeddingIdAdminRsvpsErrors, GetApiV1WeddingsByWeddingIdAdminRsvpsResponses, GetApiV1WeddingsByWeddingIdAdminSettingsData, GetApiV1WeddingsByWeddingIdAdminSettingsErrors, GetApiV1WeddingsByWeddingIdAdminSettingsResponses, GetApiV1WeddingsByWeddingIdAdminStaffData, GetApiV1WeddingsByWeddingIdAdminStaffErrors, GetApiV1WeddingsByWeddingIdAdminStaffInvitationsData, GetApiV1WeddingsByWeddingIdAdminStaffInvitationsErrors, GetApiV1WeddingsByWeddingIdAdminStaffInvitationsResponses, GetApiV1WeddingsByWeddingIdAdminStaffResponses, GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData, GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsErrors, GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsResponses, GetApiV1WeddingsByWeddingIdAuthMeData, GetApiV1WeddingsByWeddingIdAuthMeErrors, GetApiV1WeddingsByWeddingIdAuthMeResponses, GetApiV1WeddingsByWeddingIdData, GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberData, GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberErrors, GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberResponses, GetApiV1WeddingsByWeddingIdDisplayActivitiesWallData, GetApiV1WeddingsByWeddingIdDisplayActivitiesWallErrors, GetApiV1WeddingsByWeddingIdDisplayActivitiesWallResponses, GetApiV1WeddingsByWeddingIdDisplayAttendeesData, GetApiV1WeddingsByWeddingIdDisplayAttendeesErrors, GetApiV1WeddingsByWeddingIdDisplayAttendeesResponses, GetApiV1WeddingsByWeddingIdDisplayGuestsData, GetApiV1WeddingsByWeddingIdDisplayGuestsErrors, GetApiV1WeddingsByWeddingIdDisplayGuestsResponses, GetApiV1WeddingsByWeddingIdErrors, GetApiV1WeddingsByWeddingIdGuestsByGuestIdData, GetApiV1WeddingsByWeddingIdGuestsByGuestIdErrors, GetApiV1WeddingsByWeddingIdGuestsByGuestIdResponses, GetApiV1WeddingsByWeddingIdGuestsData, GetApiV1WeddingsByWeddingIdGuestsErrors, GetApiV1WeddingsByWeddingIdGuestsGroupsData, GetApiV1WeddingsByWeddingIdGuestsGroupsErrors, GetApiV1WeddingsByWeddingIdGuestsGroupsResponses, GetApiV1WeddingsByWeddingIdGuestsResponses, GetApiV1WeddingsByWeddingIdResponses, GetApiV1WeddingsByWeddingIdRsvpsTokenInfoData, GetApiV1WeddingsByWeddingIdRsvpsTokenInfoErrors, GetApiV1WeddingsByWeddingIdRsvpsTokenInfoResponses, GetApiV1WeddingsByWeddingIdSettingsData, GetApiV1WeddingsByWeddingIdSettingsErrors, GetApiV1WeddingsByWeddingIdSettingsResponses, GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentData, GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentErrors, GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentResponses, GetApiV1WeddingsByWeddingIdTablesMasterAllData, GetApiV1WeddingsByWeddingIdTablesMasterAllErrors, GetApiV1WeddingsByWeddingIdTablesMasterAllResponses, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdData, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdErrors, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsData, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsErrors, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsResponses, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdResponses, GetApiV1WeddingsByWeddingIdTablesMasterData, GetApiV1WeddingsByWeddingIdTablesMasterErrors, GetApiV1WeddingsByWeddingIdTablesMasterResponses, GetHealthzData, GetHealthzResponses, PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData, PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdErrors, PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponses, PatchApiV1WeddingsByWeddingIdAdminLineChannelData, PatchApiV1WeddingsByWeddingIdAdminLineChannelErrors, PatchApiV1WeddingsByWeddingIdAdminLineChannelResponses, PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData, PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponses, PatchApiV1WeddingsByWeddingIdAdminSettingsData, PatchApiV1WeddingsByWeddingIdAdminSettingsErrors, PatchApiV1WeddingsByWeddingIdAdminSettingsResponses, PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData, PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdErrors, PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdResponses, PostApiV1AuthLineTokenData, PostApiV1AuthLineTokenErrors, PostApiV1AuthLineTokenResponses, PostApiV1LineWebhookData, PostApiV1LineWebhookErrors, PostApiV1LineWebhookResponses, PostApiV1OrganizationsData, PostApiV1OrganizationsErrors, PostApiV1OrganizationsResponses, PostApiV1StaffInvitationsByTokenAcceptData, PostApiV1StaffInvitationsByTokenAcceptErrors, PostApiV1StaffInvitationsByTokenAcceptResponses, PostApiV1WeddingsByWeddingIdActivitiesAngpaoData, PostApiV1WeddingsByWeddingIdActivitiesAngpaoErrors, PostApiV1WeddingsByWeddingIdActivitiesAngpaoResponses, PostApiV1WeddingsByWeddingIdActivitiesBlessingsData, PostApiV1WeddingsByWeddingIdActivitiesBlessingsErrors, PostApiV1WeddingsByWeddingIdActivitiesBlessingsResponses, PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawData, PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawErrors, PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawResponses, PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetData, PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetErrors, PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetResponses, PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundData, PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundErrors, PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundResponses, PostApiV1WeddingsByWeddingIdAdminCheckinsManualData, PostApiV1WeddingsByWeddingIdAdminCheckinsManualErrors, PostApiV1WeddingsByWeddingIdAdminCheckinsManualResponses, PostApiV1WeddingsByWeddingIdAdminDisplayTokensData, PostApiV1WeddingsByWeddingIdAdminDisplayTokensErrors, PostApiV1WeddingsByWeddingIdAdminDisplayTokensResponses, PostApiV1WeddingsByWeddingIdAdminGuestsBatchData, PostApiV1WeddingsByWeddingIdAdminGuestsBatchErrors, PostApiV1WeddingsByWeddingIdAdminGuestsBatchResponses, PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteData, PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteErrors, PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteResponses, PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsData, PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsErrors, PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsResponses, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeData, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeErrors, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeResponses, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersData, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersErrors, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersResponses, PostApiV1WeddingsByWeddingIdAdminGuestsData, PostApiV1WeddingsByWeddingIdAdminGuestsErrors, PostApiV1WeddingsByWeddingIdAdminGuestsImportData, PostApiV1WeddingsByWeddingIdAdminGuestsImportErrors, PostApiV1WeddingsByWeddingIdAdminGuestsImportResponses, PostApiV1WeddingsByWeddingIdAdminGuestsParseImportData, PostApiV1WeddingsByWeddingIdAdminGuestsParseImportErrors, PostApiV1WeddingsByWeddingIdAdminGuestsParseImportResponses, PostApiV1WeddingsByWeddingIdAdminGuestsResponses, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingData, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingErrors, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingResponses, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappData, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappErrors, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappResponses, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionData, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionErrors, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultData, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultErrors, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageData, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageErrors, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdData, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdErrors, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusData, PostApiV1WeddingsByWeddingIdAdminRichmenusErrors, PostApiV1WeddingsByWeddingIdAdminRichmenusResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateData, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageData, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishData, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateData, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsData, PostApiV1WeddingsByWeddingIdAdminRichmenusSetsResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllData, PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllErrors, PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllResponses, PostApiV1WeddingsByWeddingIdAdminStaffInvitationsData, PostApiV1WeddingsByWeddingIdAdminStaffInvitationsErrors, PostApiV1WeddingsByWeddingIdAdminStaffInvitationsResponses, PostApiV1WeddingsByWeddingIdAdminTablesAssignData, PostApiV1WeddingsByWeddingIdAdminTablesAssignErrors, PostApiV1WeddingsByWeddingIdAdminTablesAssignResponses, PostApiV1WeddingsByWeddingIdAdminTablesBulkData, PostApiV1WeddingsByWeddingIdAdminTablesBulkErrors, PostApiV1WeddingsByWeddingIdAdminTablesBulkResponses, PostApiV1WeddingsByWeddingIdAdminTablesMasterData, PostApiV1WeddingsByWeddingIdAdminTablesMasterErrors, PostApiV1WeddingsByWeddingIdAdminTablesMasterImportData, PostApiV1WeddingsByWeddingIdAdminTablesMasterImportErrors, PostApiV1WeddingsByWeddingIdAdminTablesMasterImportResponses, PostApiV1WeddingsByWeddingIdAdminTablesMasterResponses, PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsData, PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsErrors, PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsResponses, PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsData, PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsErrors, PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsResponses, PostApiV1WeddingsByWeddingIdAdminTablesUnassignData, PostApiV1WeddingsByWeddingIdAdminTablesUnassignErrors, PostApiV1WeddingsByWeddingIdAdminTablesUnassignResponses, PostApiV1WeddingsByWeddingIdCheckinsData, PostApiV1WeddingsByWeddingIdCheckinsErrors, PostApiV1WeddingsByWeddingIdCheckinsResponses, PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingData, PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingErrors, PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingResponses, PostApiV1WeddingsByWeddingIdRsvpsData, PostApiV1WeddingsByWeddingIdRsvpsErrors, PostApiV1WeddingsByWeddingIdRsvpsPublicData, PostApiV1WeddingsByWeddingIdRsvpsPublicErrors, PostApiV1WeddingsByWeddingIdRsvpsPublicResponses, PostApiV1WeddingsByWeddingIdRsvpsResponses, PostApiV1WeddingsData, PostApiV1WeddingsErrors, PostApiV1WeddingsResponses, PostInternalV1OrganizationsByOrganizationIdMembersData, PostInternalV1OrganizationsByOrganizationIdMembersErrors, PostInternalV1OrganizationsByOrganizationIdMembersResponses, PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData, PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateErrors, PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateResponses, PutApiV1WeddingsByWeddingIdAdminActivitiesWallData, PutApiV1WeddingsByWeddingIdAdminActivitiesWallErrors, PutApiV1WeddingsByWeddingIdAdminActivitiesWallResponses, PutApiV1WeddingsByWeddingIdAdminStaffByUserIdData, PutApiV1WeddingsByWeddingIdAdminStaffByUserIdErrors, PutApiV1WeddingsByWeddingIdAdminStaffByUserIdResponses, PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutData, PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutErrors, PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Exchange a LINE access token for an internal API JWT token
 *
 * Verifies the LIFF-issued LINE Login access token (including channel match), syncs the LINE profile, and mints an internal API JWT token with {eventId, role} claims.
 */
export const postApiV1AuthLineToken = <ThrowOnError extends boolean = true>(options: Options<PostApiV1AuthLineTokenData, ThrowOnError>) => (options.client ?? client).post<PostApiV1AuthLineTokenResponses, PostApiV1AuthLineTokenErrors, ThrowOnError>({
    url: '/api/v1/auth/line/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * LINE Messaging webhook callback
 *
 * Receives LINE platform events for the configured wedding (LINE_DESTINATION_WEDDING_ID). Authenticated by the x-line-signature HMAC over the raw body, not a bearer token. Events are acked immediately and processed asynchronously; retried deliveries dedupe on webhookEventId.
 */
export const postApiV1LineWebhook = <ThrowOnError extends boolean = true>(options: Options<PostApiV1LineWebhookData, ThrowOnError>) => (options.client ?? client).post<PostApiV1LineWebhookResponses, PostApiV1LineWebhookErrors, ThrowOnError>({ url: '/api/v1/line/webhook', ...options });

/**
 * List the organizations the caller belongs to
 *
 * Membership discovery for the admin app's organization picker. Never 404s — an empty list just means no memberships (shouldn't happen once every wedding has an auto-bootstrapped organization).
 */
export const getApiV1MeOrganizations = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MeOrganizationsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MeOrganizationsResponses, GetApiV1MeOrganizationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/me/organizations',
    ...options
});

/**
 * List every wedding the caller can access
 *
 * The admin app's unified home-page list — every wedding reachable through organization membership, plus every wedding reachable only through a WeddingStaff invitation. Never 404s — an empty list just means no accessible weddings.
 */
export const getApiV1MeWeddings = <ThrowOnError extends boolean = true>(options?: Options<GetApiV1MeWeddingsData, ThrowOnError>) => (options?.client ?? client).get<GetApiV1MeWeddingsResponses, GetApiV1MeWeddingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/me/weddings',
    ...options
});

/**
 * Create an organization account
 *
 * Creates an organization; the caller becomes its first member automatically.
 */
export const postApiV1Organizations = <ThrowOnError extends boolean = true>(options: Options<PostApiV1OrganizationsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1OrganizationsResponses, PostApiV1OrganizationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/organizations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get an organization's profile
 *
 * Requires the caller to be a member of this organization.
 */
export const getApiV1OrganizationsByOrganizationId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1OrganizationsByOrganizationIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1OrganizationsByOrganizationIdResponses, GetApiV1OrganizationsByOrganizationIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/organizations/{organizationId}',
    ...options
});

/**
 * List an organization's members
 *
 * Phase-1 read-only member list — no invite/role-management endpoints yet. Requires the caller to be a member.
 */
export const getApiV1OrganizationsByOrganizationIdMembers = <ThrowOnError extends boolean = true>(options: Options<GetApiV1OrganizationsByOrganizationIdMembersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1OrganizationsByOrganizationIdMembersResponses, GetApiV1OrganizationsByOrganizationIdMembersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/organizations/{organizationId}/members',
    ...options
});

/**
 * List all weddings under an organization
 *
 * The organization dashboard's event list. Requires the caller to be a member — an IDOR target if membership weren't checked.
 */
export const getApiV1OrganizationsByOrganizationIdWeddings = <ThrowOnError extends boolean = true>(options: Options<GetApiV1OrganizationsByOrganizationIdWeddingsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1OrganizationsByOrganizationIdWeddingsResponses, GetApiV1OrganizationsByOrganizationIdWeddingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/organizations/{organizationId}/weddings',
    ...options
});

/**
 * Preview a staff invitation by its raw token
 *
 * Unauthenticated: resolves the accept-link token so the landing page can show the invitee what they're accepting before they sign in. Every rejection reason (unknown/expired/revoked/consumed token) maps to the same generic 404 — this must not leak which.
 */
export const getApiV1StaffInvitationsByToken = <ThrowOnError extends boolean = true>(options: Options<GetApiV1StaffInvitationsByTokenData, ThrowOnError>) => (options.client ?? client).get<GetApiV1StaffInvitationsByTokenResponses, GetApiV1StaffInvitationsByTokenErrors, ThrowOnError>({ url: '/api/v1/staff-invitations/{token}', ...options });

/**
 * Accept a staff invitation
 *
 * Grants the WeddingStaff row and consumes the invitation. Requires a Better Auth (service-verified) token whose `email` claim matches the invitation and whose `emailVerified` claim is true — a Firebase (LIFF guest) token is rejected outright, since it carries no meaningful email claim to compare against.
 */
export const postApiV1StaffInvitationsByTokenAccept = <ThrowOnError extends boolean = true>(options: Options<PostApiV1StaffInvitationsByTokenAcceptData, ThrowOnError>) => (options.client ?? client).post<PostApiV1StaffInvitationsByTokenAcceptResponses, PostApiV1StaffInvitationsByTokenAcceptErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/staff-invitations/{token}/accept',
    ...options
});

/**
 * Create a wedding
 *
 * No existing wedding to check access against yet, so only identity is required. If organizationId is omitted, the caller's own organization is used (bootstrapped automatically if they have none yet) — see wedding.Service.CreateWedding. If organizationId is set, the caller must already be a member of that organization — otherwise anyone could create weddings under an organization just by supplying its ID.
 */
export const postApiV1Weddings = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsResponses, PostApiV1WeddingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a wedding
 *
 * Requires proven access to this wedding (owner or member of its organizer) — already verified by the time this handler runs.
 */
export const getApiV1WeddingsByWeddingId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdResponses, GetApiV1WeddingsByWeddingIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}',
    ...options
});

/**
 * Submit an e-angpao transfer slip
 *
 * Multipart upload; the response includes a ready-to-use image URL (no client-side storage access needed).
 */
export const postApiV1WeddingsByWeddingIdActivitiesAngpao = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdActivitiesAngpaoData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdActivitiesAngpaoResponses, PostApiV1WeddingsByWeddingIdActivitiesAngpaoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/activities/angpao',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * List blessings (newest first)
 *
 * Initial snapshot for the wall display; live updates arrive over the realtime channel.
 */
export const getApiV1WeddingsByWeddingIdActivitiesBlessings = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdActivitiesBlessingsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdActivitiesBlessingsResponses, GetApiV1WeddingsByWeddingIdActivitiesBlessingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/activities/blessings',
    ...options
});

/**
 * Log a wedding blessing
 */
export const postApiV1WeddingsByWeddingIdActivitiesBlessings = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdActivitiesBlessingsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdActivitiesBlessingsResponses, PostApiV1WeddingsByWeddingIdActivitiesBlessingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/activities/blessings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Draw a random number (lucky draw)
 *
 * Server-side draw: honors the admin's forceNextWin/targetNumber, logs the attempt, and on a win atomically ends the game and archives the session — of two concurrent winning draws exactly one lands.
 */
export const postApiV1WeddingsByWeddingIdActivitiesRandomNumberDraw = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawResponses, PostApiV1WeddingsByWeddingIdActivitiesRandomNumberDrawErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/activities/random-number/draw',
    ...options
});

/**
 * Guest: get the random-number game state
 *
 * Guest-safe subset of the state (status, settings, winners, showQRCode) — targetNumber and forceNextWin are stripped, see toGuestSafeRandomNumberData.
 */
export const getApiV1WeddingsByWeddingIdActivitiesRandomNumberState = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateResponses, GetApiV1WeddingsByWeddingIdActivitiesRandomNumberStateErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/activities/random-number/state',
    ...options
});

/**
 * Admin: list e-angpao submissions with resolved image URLs
 *
 * Replaces the frontend's realtime Firestore listener + client-side getDownloadURL.
 */
export const getApiV1WeddingsByWeddingIdAdminActivitiesAngpao = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoResponses, GetApiV1WeddingsByWeddingIdAdminActivitiesAngpaoErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/activities/angpao',
    ...options
});

/**
 * Admin: reset the random-number game
 */
export const postApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberReset = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetResponses, PostApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberResetErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/activities/random-number/reset',
    ...options
});

/**
 * Admin: get the random-number game state
 *
 * Full state including targetNumber/forceNextWin (staff-only — never expose these to guests). Seeds the default state on first call.
 */
export const getApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberState = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateResponses, GetApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/activities/random-number/state',
    ...options
});

/**
 * Admin: update the random-number game state
 *
 * Partial merge of {status, settings, targetNumber, forceNextWin, showQRCode, startedAt, winners} — replaces the admin UI's former direct RTDB writes.
 */
export const putApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberState = <ThrowOnError extends boolean = true>(options: Options<PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateData, ThrowOnError>) => (options.client ?? client).put<PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateResponses, PutApiV1WeddingsByWeddingIdAdminActivitiesRandomNumberStateErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/activities/random-number/state',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: list archived game sessions (newest first)
 *
 * Replaces the frontend's direct Firestore activity_sessions query.
 */
export const getApiV1WeddingsByWeddingIdAdminActivitiesSessions = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsResponses, GetApiV1WeddingsByWeddingIdAdminActivitiesSessionsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/activities/sessions',
    ...options
});

/**
 * Admin: get the wall state
 *
 * Seeds the default state (Thai default session) on first call, matching ok-wedding.
 */
export const getApiV1WeddingsByWeddingIdAdminActivitiesWall = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminActivitiesWallData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminActivitiesWallResponses, GetApiV1WeddingsByWeddingIdAdminActivitiesWallErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/activities/wall',
    ...options
});

/**
 * Admin: update the wall state (partial merge)
 */
export const putApiV1WeddingsByWeddingIdAdminActivitiesWall = <ThrowOnError extends boolean = true>(options: Options<PutApiV1WeddingsByWeddingIdAdminActivitiesWallData, ThrowOnError>) => (options.client ?? client).put<PutApiV1WeddingsByWeddingIdAdminActivitiesWallResponses, PutApiV1WeddingsByWeddingIdAdminActivitiesWallErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/activities/wall',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: upload a wall background image
 */
export const postApiV1WeddingsByWeddingIdAdminActivitiesWallBackground = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundResponses, PostApiV1WeddingsByWeddingIdAdminActivitiesWallBackgroundErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/activities/wall/background',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Admin: list checked-in parties (newest first)
 */
export const getApiV1WeddingsByWeddingIdAdminCheckins = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminCheckinsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminCheckinsResponses, GetApiV1WeddingsByWeddingIdAdminCheckinsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/checkins',
    ...options
});

/**
 * Admin: manually check in a guest without LINE
 *
 * No attendee record is created and no LINE message is sent; the check-in window is ignored. Repeated manual check-ins keep incrementing the party's count.
 */
export const postApiV1WeddingsByWeddingIdAdminCheckinsManual = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminCheckinsManualData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminCheckinsManualResponses, PostApiV1WeddingsByWeddingIdAdminCheckinsManualErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/checkins/manual',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: reset a party's check-in
 *
 * Reverts the guest to pending and deletes all its attendee records, atomically (transaction).
 */
export const deleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdResponses, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/checkins/{guestId}',
    ...options
});

/**
 * Admin: remove one LINE user from a party's check-in
 *
 * Deletes the attendee and decrements the party's checkedInCount (at 0 the party reverts to pending), atomically.
 */
export const deleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdResponses, DeleteApiV1WeddingsByWeddingIdAdminCheckinsByGuestIdUsersByLineUserIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/checkins/{guestId}/users/{lineUserId}',
    ...options
});

/**
 * Admin: list display tokens
 *
 * Raw token values are never returned — only label, expiry and revocation state.
 */
export const getApiV1WeddingsByWeddingIdAdminDisplayTokens = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminDisplayTokensData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminDisplayTokensResponses, GetApiV1WeddingsByWeddingIdAdminDisplayTokensErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/display-tokens',
    ...options
});

/**
 * Admin: mint a display token
 *
 * Returns the raw token exactly once — only its hash is stored, so it cannot be shown again. Staff paste it into the venue device's URL.
 */
export const postApiV1WeddingsByWeddingIdAdminDisplayTokens = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminDisplayTokensData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminDisplayTokensResponses, PostApiV1WeddingsByWeddingIdAdminDisplayTokensErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/display-tokens',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: revoke a display token
 *
 * Kills the credential immediately — the answer to a venue URL that got shared, without waiting for expiry.
 */
export const deleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdResponses, DeleteApiV1WeddingsByWeddingIdAdminDisplayTokensByTokenIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/display-tokens/{tokenId}',
    ...options
});

/**
 * Admin: list guests with full details
 *
 * Same filters as the guest-facing list, plus phone/notes/lineUserIds/preloadedUsers on each row.
 */
export const getApiV1WeddingsByWeddingIdAdminGuests = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminGuestsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminGuestsResponses, GetApiV1WeddingsByWeddingIdAdminGuestsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests',
    ...options
});

/**
 * Create a guest in the master list
 */
export const postApiV1WeddingsByWeddingIdAdminGuests = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminGuestsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminGuestsResponses, PostApiV1WeddingsByWeddingIdAdminGuestsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: batch create or update guest list
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsBatch = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminGuestsBatchData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminGuestsBatchResponses, PostApiV1WeddingsByWeddingIdAdminGuestsBatchErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk delete guests
 *
 * Cascades: attendees and table assignments of all deleted guests are removed.
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsBulkDelete = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteResponses, PostApiV1WeddingsByWeddingIdAdminGuestsBulkDeleteErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/bulk-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bulk map LINE user IDs and metadata to guests
 *
 * Adds each lineUserId to its guest's party ($addToSet) with preloaded metadata; already-checked-in attendees get their metadata updated and rich menus re-evaluated.
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIds = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsResponses, PostApiV1WeddingsByWeddingIdAdminGuestsBulkMapLineIdsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/bulk-map-line-ids',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import guests from CSV
 *
 * Multipart CSV upload, upserted by fullName. Columns: fullName, displayName, group, side, followers, lineUserId, maritalStatus, tableNumber. Rows with a tableNumber auto-create the table and assignment. Optional "mappings" form field: JSON {side: {raw: groom|bride}, maritalStatus: {raw: single|not_single|prefer_not_to_say}}.
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsImport = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminGuestsImportData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminGuestsImportResponses, PostApiV1WeddingsByWeddingIdAdminGuestsImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Admin: parse uploaded guest list file (.csv or .xlsx)
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsParseImport = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminGuestsParseImportData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminGuestsParseImportResponses, PostApiV1WeddingsByWeddingIdAdminGuestsParseImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/parse-import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Delete a guest
 *
 * Cascades: the party's attendees and table assignment are removed too.
 */
export const deleteApiV1WeddingsByWeddingIdAdminGuestsByGuestId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponses, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/{guestId}',
    ...options
});

/**
 * Admin: get one guest with checked-in users
 */
export const getApiV1WeddingsByWeddingIdAdminGuestsByGuestId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponses, GetApiV1WeddingsByWeddingIdAdminGuestsByGuestIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/{guestId}',
    ...options
});

/**
 * Update guest details
 *
 * Partial update. Changing expectedFollowers syncs the assignment's seats; on checked-in guests, preloaded metadata propagates to attendees and their rich menus re-evaluate.
 */
export const patchApiV1WeddingsByWeddingIdAdminGuestsByGuestId = <ThrowOnError extends boolean = true>(options: Options<PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdResponses, PatchApiV1WeddingsByWeddingIdAdminGuestsByGuestIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/{guestId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: acknowledge a public registration (create new or merge)
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledge = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeResponses, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdAcknowledgeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/{guestId}/acknowledge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: link a LINE account to a guest
 */
export const postApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsers = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersResponses, PostApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/{guestId}/line-users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: unlink a LINE account from a guest
 */
export const deleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdResponses, DeleteApiV1WeddingsByWeddingIdAdminGuestsByGuestIdLineUsersByLineUserIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/guests/{guestId}/line-users/{lineUserId}',
    ...options
});

/**
 * Admin: get the wedding's LINE MINI App & Messaging API configuration
 *
 * Returns public IDs, masked secret boolean flags, expected LIFF endpoint URL, and timestamp. An unconfigured wedding returns an empty object, not a 404.
 */
export const getApiV1WeddingsByWeddingIdAdminLineChannel = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminLineChannelData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminLineChannelResponses, GetApiV1WeddingsByWeddingIdAdminLineChannelErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/line-channel',
    ...options
});

/**
 * Admin: set the wedding's LINE MINI App & Messaging API configuration
 *
 * Partial update — omitted fields are left unchanged. Creates the row on first call.
 */
export const patchApiV1WeddingsByWeddingIdAdminLineChannel = <ThrowOnError extends boolean = true>(options: Options<PatchApiV1WeddingsByWeddingIdAdminLineChannelData, ThrowOnError>) => (options.client ?? client).patch<PatchApiV1WeddingsByWeddingIdAdminLineChannelResponses, PatchApiV1WeddingsByWeddingIdAdminLineChannelErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/line-channel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: verify LINE Messaging API configuration
 *
 * Verifies Messaging Channel ID, Secret (via stateless token + bot info) and Access Token (bot info), ensuring both bot profiles match.
 */
export const postApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessaging = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingResponses, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMessagingErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/line-channel/verify-messaging',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: verify LINE MINI App channel configuration
 *
 * Verifies LIFF app via LINE contextToken API, decoding JWT claims, checking channel ID prefix match, and verifying channel secret with OAuth2 stateless token API.
 */
export const postApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniapp = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappResponses, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifyMiniappErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/line-channel/verify-miniapp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: create Same-Provider verification session
 *
 * Creates a 10-minute verification session storing unsaved messagingAccessToken and liffId, returning verifyToken.
 */
export const postApiV1WeddingsByWeddingIdAdminLineChannelVerifySession = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionResponses, PostApiV1WeddingsByWeddingIdAdminLineChannelVerifySessionErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/line-channel/verify-session',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: subscribe to Same-Provider verification SSE stream
 *
 * Subscribes to live verification stream using token parameter from verify-session.
 */
export const getApiV1WeddingsByWeddingIdAdminLineChannelVerifyStream = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminLineChannelVerifyStreamData, ThrowOnError>) => (options.client ?? client).sse.get<GetApiV1WeddingsByWeddingIdAdminLineChannelVerifyStreamResponses, GetApiV1WeddingsByWeddingIdAdminLineChannelVerifyStreamErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/line-channel/verify-stream',
    ...options
});

/**
 * Admin: list active LINE users for wedding
 */
export const getApiV1WeddingsByWeddingIdAdminLineUsers = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminLineUsersData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminLineUsersResponses, GetApiV1WeddingsByWeddingIdAdminLineUsersErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/line-users',
    ...options
});

/**
 * Admin: list LINE rich menus
 *
 * Returns only Rich Menus created and stored by this platform for the wedding, including conditions, priority, and image metadata.
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenus = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminRichmenusResponses, GetApiV1WeddingsByWeddingIdAdminRichmenusErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus',
    ...options
});

/**
 * Admin: create a LINE rich menu
 *
 * Registers the menu with LINE ("liff" area actions are compiled to line://app deep links) and stores it locally with the conditions/priority metadata. Upload an image afterwards — LINE requires one before the menu can be linked or set default.
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenus = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminRichmenusData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminRichmenusResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: cancel the default LINE rich menu
 */
export const deleteApiV1WeddingsByWeddingIdAdminRichmenusDefault = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultResponses, DeleteApiV1WeddingsByWeddingIdAdminRichmenusDefaultErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/default',
    ...options
});

/**
 * Admin: unlink the personal rich menu from one LINE user
 *
 * The user falls back to the default rich menu. Unlinking a user with no personal menu succeeds.
 */
export const deleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdResponses, DeleteApiV1WeddingsByWeddingIdAdminRichmenusLinkByLineUserIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/link/{lineUserId}',
    ...options
});

/**
 * Admin: list Rich Menu Set drafts
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenusSets = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/sets',
    ...options
});

/**
 * Admin: create a Rich Menu Set draft
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSets = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/sets',
    ...options
});

/**
 * Admin: delete Rich Menu Set
 */
export const deleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/sets/{setId}',
    ...options
});

/**
 * Admin: get Rich Menu Set draft
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/sets/{setId}',
    ...options
});

/**
 * Admin: autosave Rich Menu Set draft
 */
export const patchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetId = <ThrowOnError extends boolean = true>(options: Options<PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/sets/{setId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: duplicate Rich Menu Set
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicate = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdDuplicateResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/sets/{setId}/duplicate',
    ...options
});

/**
 * Admin: upload a Rich Menu Set page image
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImage = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPagesByPageIdImageResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/sets/{setId}/pages/{pageId}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Admin: publish Rich Menu Set
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublish = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdPublishResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/sets/{setId}/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: validate Rich Menu Set draft
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidate = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminRichmenusSetsBySetIdValidateResponses, unknown, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/sets/{setId}/validate',
    ...options
});

/**
 * Admin: re-evaluate conditional rich menus for all users
 *
 * Runs the condition rule engine for every known LINE user of the wedding (attendees + guests' mapped LINE accounts), linking the matching menu or unlinking to the default.
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusSyncAll = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusSyncAllErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/sync-all',
    ...options
});

/**
 * Admin: get the rich menu linked to one LINE user
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdResponses, GetApiV1WeddingsByWeddingIdAdminRichmenusUserByLineUserIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/user/{lineUserId}',
    ...options
});

/**
 * Admin: delete a LINE rich menu
 */
export const deleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdResponses, DeleteApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/{menuId}',
    ...options
});

/**
 * Admin: get one LINE rich menu
 */
export const getApiV1WeddingsByWeddingIdAdminRichmenusByMenuId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdResponses, GetApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/{menuId}',
    ...options
});

/**
 * Admin: set the default LINE rich menu
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefault = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdDefaultErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/{menuId}/default',
    ...options
});

/**
 * Admin: upload a rich menu background image
 *
 * Sets the image on LINE (JPEG/PNG, max 1MB, 2500x1686 or 2500x843) and mirrors it to object storage for admin preview.
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImage = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/{menuId}/image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Admin: link a rich menu to one LINE user
 */
export const postApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserId = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdResponses, PostApiV1WeddingsByWeddingIdAdminRichmenusByMenuIdLinkByLineUserIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/richmenus/{menuId}/link/{lineUserId}',
    ...options
});

/**
 * Admin: list RSVP responses (newest first)
 */
export const getApiV1WeddingsByWeddingIdAdminRsvps = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminRsvpsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminRsvpsResponses, GetApiV1WeddingsByWeddingIdAdminRsvpsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/rsvps',
    ...options
});

/**
 * Admin: get full wedding settings
 */
export const getApiV1WeddingsByWeddingIdAdminSettings = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminSettingsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminSettingsResponses, GetApiV1WeddingsByWeddingIdAdminSettingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/settings',
    ...options
});

/**
 * Admin: update wedding settings
 *
 * Shallow-merges the given top-level keys into the settings blob (ok-wedding's RTDB update() semantics).
 */
export const patchApiV1WeddingsByWeddingIdAdminSettings = <ThrowOnError extends boolean = true>(options: Options<PatchApiV1WeddingsByWeddingIdAdminSettingsData, ThrowOnError>) => (options.client ?? client).patch<PatchApiV1WeddingsByWeddingIdAdminSettingsResponses, PatchApiV1WeddingsByWeddingIdAdminSettingsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List a wedding's staff grants
 *
 * Every WeddingStaff row for this wedding, enriched with the LINE profile when known. The wedding owner and organizer members have implicit unrestricted access and do not appear here.
 */
export const getApiV1WeddingsByWeddingIdAdminStaff = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminStaffData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminStaffResponses, GetApiV1WeddingsByWeddingIdAdminStaffErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/staff',
    ...options
});

/**
 * List a wedding's pending staff invitations
 *
 * Every still-acceptable (not expired/consumed/revoked) invitation for this wedding — no token or hash is ever included.
 */
export const getApiV1WeddingsByWeddingIdAdminStaffInvitations = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminStaffInvitationsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminStaffInvitationsResponses, GetApiV1WeddingsByWeddingIdAdminStaffInvitationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/staff/invitations',
    ...options
});

/**
 * Invite a staff member by email
 *
 * Mints an accept-link invitation and emails it to the invitee. Requires unrestricted admin access, same as staff management — the raw accept token is never returned in this response, only delivered via email.
 */
export const postApiV1WeddingsByWeddingIdAdminStaffInvitations = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminStaffInvitationsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminStaffInvitationsResponses, PostApiV1WeddingsByWeddingIdAdminStaffInvitationsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/staff/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke a pending staff invitation
 *
 * Invalidates the accept-link so the invitee can no longer use it.
 */
export const deleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdResponses, DeleteApiV1WeddingsByWeddingIdAdminStaffInvitationsByInvitationIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/staff/invitations/{invitationId}',
    ...options
});

/**
 * Revoke a staff member
 *
 * Deletes the WeddingStaff row — the user keeps guest access, loses all admin modules.
 */
export const deleteApiV1WeddingsByWeddingIdAdminStaffByUserId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdResponses, DeleteApiV1WeddingsByWeddingIdAdminStaffByUserIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/staff/{userId}',
    ...options
});

/**
 * Grant or update a staff member
 *
 * Creates or replaces the WeddingStaff row for userId. Requires unrestricted admin access — module-scoped staff cannot manage staff (no self-escalation).
 */
export const putApiV1WeddingsByWeddingIdAdminStaffByUserId = <ThrowOnError extends boolean = true>(options: Options<PutApiV1WeddingsByWeddingIdAdminStaffByUserIdData, ThrowOnError>) => (options.client ?? client).put<PutApiV1WeddingsByWeddingIdAdminStaffByUserIdResponses, PutApiV1WeddingsByWeddingIdAdminStaffByUserIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/staff/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Assign a guest party to a table
 *
 * Capacity-checked upsert (one assignment per party) with optional seat slots. Stamps the guest's denormalized tableNumber and seatDisplay, propagates to checked-in attendees, and notifies them via LINE.
 */
export const postApiV1WeddingsByWeddingIdAdminTablesAssign = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminTablesAssignData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminTablesAssignResponses, PostApiV1WeddingsByWeddingIdAdminTablesAssignErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/assign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Admin: list all table assignments
 *
 * Paginated, sorted by tableNumber. Guests and tables are preloaded.
 */
export const getApiV1WeddingsByWeddingIdAdminTablesAssignments = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsResponses, GetApiV1WeddingsByWeddingIdAdminTablesAssignmentsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/assignments',
    ...options
});

/**
 * Assign multiple guest parties to one table
 *
 * With sync=true, parties currently on the table but absent from the list are unassigned first. Capacity checked once for the batch.
 */
export const postApiV1WeddingsByWeddingIdAdminTablesBulk = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminTablesBulkData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminTablesBulkResponses, PostApiV1WeddingsByWeddingIdAdminTablesBulkErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Create a venue table / map point
 */
export const postApiV1WeddingsByWeddingIdAdminTablesMaster = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminTablesMasterData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminTablesMasterResponses, PostApiV1WeddingsByWeddingIdAdminTablesMasterErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/master',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Import venue tables from CSV
 *
 * Multipart CSV upload, upserted by tableNumber. Columns: tableNumber, capacity, notes, x, y, type, shape, width, height.
 */
export const postApiV1WeddingsByWeddingIdAdminTablesMasterImport = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminTablesMasterImportData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminTablesMasterImportResponses, PostApiV1WeddingsByWeddingIdAdminTablesMasterImportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/master/import',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Bulk update venue tables / layout positions and dimensions
 */
export const putApiV1WeddingsByWeddingIdAdminTablesMasterLayout = <ThrowOnError extends boolean = true>(options: Options<PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutData, ThrowOnError>) => (options.client ?? client).put<PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutResponses, PutApiV1WeddingsByWeddingIdAdminTablesMasterLayoutErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/master/layout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a venue table
 */
export const deleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableId = <ThrowOnError extends boolean = true>(options: Options<DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdResponses, DeleteApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/master/{tableId}',
    ...options
});

/**
 * Update a venue table / map point
 */
export const patchApiV1WeddingsByWeddingIdAdminTablesMasterByTableId = <ThrowOnError extends boolean = true>(options: Options<PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdData, ThrowOnError>) => (options.client ?? client).patch<PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdResponses, PatchApiV1WeddingsByWeddingIdAdminTablesMasterByTableIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/master/{tableId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync all guest assignments and seat slots for a table
 *
 * Atomically synchronizes all assignments and specific seat slots on a table. Any guests previously assigned to this table but absent from the request are unassigned. Capacity and seat ranges are checked in a single transaction.
 */
export const postApiV1WeddingsByWeddingIdAdminTablesSyncAssignments = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsResponses, PostApiV1WeddingsByWeddingIdAdminTablesSyncAssignmentsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/sync-assignments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Recompute assignment seats from guests' expectedFollowers
 *
 * Drift repair for the denormalized seats field.
 */
export const postApiV1WeddingsByWeddingIdAdminTablesSyncSeats = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsResponses, PostApiV1WeddingsByWeddingIdAdminTablesSyncSeatsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/sync-seats',
    ...options
});

/**
 * Remove a guest party's table assignment
 */
export const postApiV1WeddingsByWeddingIdAdminTablesUnassign = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdAdminTablesUnassignData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdAdminTablesUnassignResponses, PostApiV1WeddingsByWeddingIdAdminTablesUnassignErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/admin/tables/unassign',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the caller's status and profile
 *
 * Check-in state, LINE profile, staff role/modules, current table (when checked in), and the preloaded guest party mapped to this LINE account (when not yet checked in — used for check-in prefill).
 */
export const getApiV1WeddingsByWeddingIdAuthMe = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdAuthMeData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdAuthMeResponses, GetApiV1WeddingsByWeddingIdAuthMeErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/auth/me',
    ...options
});

/**
 * Check in the authenticated LINE guest
 *
 * Resolves the caller's party (guestId → mapped LINE account → walk-in create), enforces the check-in window from settings, and guards against double check-in atomically. Sends the LINE success message afterwards.
 */
export const postApiV1WeddingsByWeddingIdCheckins = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdCheckinsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdCheckinsResponses, PostApiV1WeddingsByWeddingIdCheckinsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/checkins',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Display: lucky-draw random-number state
 */
export const getApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumber = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberResponses, GetApiV1WeddingsByWeddingIdDisplayActivitiesRandomNumberErrors, ThrowOnError>({ url: '/api/v1/weddings/{weddingId}/display/activities/random-number', ...options });

/**
 * Display: guest wall state
 *
 * Same state the backoffice drives, read by the projector. The winner clears itself once its deadline passes (docs/adr/0003) — the display never writes.
 */
export const getApiV1WeddingsByWeddingIdDisplayActivitiesWall = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdDisplayActivitiesWallData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdDisplayActivitiesWallResponses, GetApiV1WeddingsByWeddingIdDisplayActivitiesWallErrors, ThrowOnError>({ url: '/api/v1/weddings/{weddingId}/display/activities/wall', ...options });

/**
 * Display: every checked-in attendee
 *
 * Unpaged on purpose — the guest wall renders one bubble per attendee and rescales its layout past certain counts, so a page of them is the wrong shape. Authorized by a display token, not a user session.
 */
export const getApiV1WeddingsByWeddingIdDisplayAttendees = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdDisplayAttendeesData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdDisplayAttendeesResponses, GetApiV1WeddingsByWeddingIdDisplayAttendeesErrors, ThrowOnError>({ url: '/api/v1/weddings/{weddingId}/display/attendees', ...options });

/**
 * Display: guest lookup for the kiosk
 *
 * Name search returning seat information only — a strict subset of the guest-facing list, since a kiosk is unattended hardware in a public lobby. Requires a search term and is not pageable: it looks one guest up, it does not enumerate the list.
 */
export const getApiV1WeddingsByWeddingIdDisplayGuests = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdDisplayGuestsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdDisplayGuestsResponses, GetApiV1WeddingsByWeddingIdDisplayGuestsErrors, ThrowOnError>({ url: '/api/v1/weddings/{weddingId}/display/guests', ...options });

/**
 * List guests in the master list
 *
 * Filtered, paginated guest list. Filters: q (name substring), group, side, status, isTableAssigned; sortBy fullName|group|expectedFollowers|status|rsvpAt|checkedInAt|tableNumber|createdAt.
 */
export const getApiV1WeddingsByWeddingIdGuests = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdGuestsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdGuestsResponses, GetApiV1WeddingsByWeddingIdGuestsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/guests',
    ...options
});

/**
 * Get all unique guest groups
 */
export const getApiV1WeddingsByWeddingIdGuestsGroups = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdGuestsGroupsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdGuestsGroupsResponses, GetApiV1WeddingsByWeddingIdGuestsGroupsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/guests/groups',
    ...options
});

/**
 * Get one guest
 */
export const getApiV1WeddingsByWeddingIdGuestsByGuestId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdGuestsByGuestIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdGuestsByGuestIdResponses, GetApiV1WeddingsByWeddingIdGuestsByGuestIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/guests/{guestId}',
    ...options
});

/**
 * Ping Same-Provider verification from MINI App
 *
 * Validates verifyToken, extracts user ID from LINE access token, and queries LINE Messaging API to confirm user ID exists in the channel.
 */
export const postApiV1WeddingsByWeddingIdLineChannelVerifyProviderPing = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingResponses, PostApiV1WeddingsByWeddingIdLineChannelVerifyProviderPingErrors, ThrowOnError>({
    url: '/api/v1/weddings/{weddingId}/line-channel/verify-provider-ping',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit an RSVP using an invitation token
 *
 * Unauthenticated by design — the invitation token IS the credential. Resubmitting overwrites the previous answer and keeps the original submittedAt.
 */
export const postApiV1WeddingsByWeddingIdRsvps = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdRsvpsData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdRsvpsResponses, PostApiV1WeddingsByWeddingIdRsvpsErrors, ThrowOnError>({
    url: '/api/v1/weddings/{weddingId}/rsvps',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Submit a public RSVP without an invitation token
 *
 * Unauthenticated — creates an unacknowledged EventGuest record with RegistrationSource: "public".
 */
export const postApiV1WeddingsByWeddingIdRsvpsPublic = <ThrowOnError extends boolean = true>(options: Options<PostApiV1WeddingsByWeddingIdRsvpsPublicData, ThrowOnError>) => (options.client ?? client).post<PostApiV1WeddingsByWeddingIdRsvpsPublicResponses, PostApiV1WeddingsByWeddingIdRsvpsPublicErrors, ThrowOnError>({
    url: '/api/v1/weddings/{weddingId}/rsvps/public',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get guest details by invitation token
 */
export const getApiV1WeddingsByWeddingIdRsvpsTokenInfo = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdRsvpsTokenInfoData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdRsvpsTokenInfoResponses, GetApiV1WeddingsByWeddingIdRsvpsTokenInfoErrors, ThrowOnError>({ url: '/api/v1/weddings/{weddingId}/rsvps/token-info', ...options });

/**
 * Get wedding settings (public)
 *
 * No auth — kiosk/signage displays read this before any login, matching ok-wedding's public GET /settings. LINE notification templates are stripped from the public payload.
 */
export const getApiV1WeddingsByWeddingIdSettings = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdSettingsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdSettingsResponses, GetApiV1WeddingsByWeddingIdSettingsErrors, ThrowOnError>({ url: '/api/v1/weddings/{weddingId}/settings', ...options });

/**
 * Get a guest party's table assignment
 *
 * Plain guests see null until the party has checked in (seat reveal at the event); staff always see it.
 */
export const getApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignment = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentResponses, GetApiV1WeddingsByWeddingIdTablesGuestsByGuestIdAssignmentErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/tables/guests/{guestId}/assignment',
    ...options
});

/**
 * List venue tables with occupancy
 */
export const getApiV1WeddingsByWeddingIdTablesMaster = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdTablesMasterData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdTablesMasterResponses, GetApiV1WeddingsByWeddingIdTablesMasterErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/tables/master',
    ...options
});

/**
 * List all venue tables (unpaginated, for the seating map)
 */
export const getApiV1WeddingsByWeddingIdTablesMasterAll = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdTablesMasterAllData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdTablesMasterAllResponses, GetApiV1WeddingsByWeddingIdTablesMasterAllErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/tables/master/all',
    ...options
});

/**
 * Get one venue table
 */
export const getApiV1WeddingsByWeddingIdTablesMasterByTableId = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdTablesMasterByTableIdData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdTablesMasterByTableIdResponses, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/tables/master/{tableId}',
    ...options
});

/**
 * List guest parties assigned to a table
 */
export const getApiV1WeddingsByWeddingIdTablesMasterByTableIdGuests = <ThrowOnError extends boolean = true>(options: Options<GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsData, ThrowOnError>) => (options.client ?? client).get<GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsResponses, GetApiV1WeddingsByWeddingIdTablesMasterByTableIdGuestsErrors, ThrowOnError>({
    security: [{ name: 'Authorization', type: 'apiKey' }],
    url: '/api/v1/weddings/{weddingId}/tables/master/{tableId}/guests',
    ...options
});

/**
 * Health check
 *
 * Reports whether the API process is up. Does not check MongoDB connectivity.
 */
export const getHealthz = <ThrowOnError extends boolean = true>(options?: Options<GetHealthzData, ThrowOnError>) => (options?.client ?? client).get<GetHealthzResponses, unknown, ThrowOnError>({ url: '/healthz', ...options });

/**
 * Sync a membership accepted on the Better Auth side into this API
 *
 * Internal service-to-service endpoint (X-Internal-Secret, not a user bearer token). Called by wedding-tech-auth after an organization invitation is accepted, so the Go API's own authorization checks (which never read Better Auth's collections) recognize the new member. Not part of the public API surface — no Swagger @Security/@Tags.
 */
export const postInternalV1OrganizationsByOrganizationIdMembers = <ThrowOnError extends boolean = true>(options: Options<PostInternalV1OrganizationsByOrganizationIdMembersData, ThrowOnError>) => (options.client ?? client).post<PostInternalV1OrganizationsByOrganizationIdMembersResponses, PostInternalV1OrganizationsByOrganizationIdMembersErrors, ThrowOnError>({
    url: '/internal/v1/organizations/{organizationId}/members',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
